/**
 * BLOG_TEMPLATE_ROUTES — the canonical {path, template} descriptor for the four
 * marketing blog routes (BLOG-STD-001 index / post / category / tag).
 *
 * ONE SSOT consumed by both shapes of blog-route consumer:
 *   1. Per-app `MarketingWebsiteApp`s spread it into their `createMarketingApp`
 *      `routes` array (`...BLOG_TEMPLATE_ROUTES`).
 *   2. Apps that build their own `<Routes>` map each descriptor to a
 *      `<BlogTemplateRoute>` element (purchase-web's `TenantSiteApp`).
 *
 * Promoted in BLOG-REMEDIATE-001 WS-C: before this, all 8 app marketing sites
 * hardcoded the same four pairs independently, and the vanity-domain blog work
 * would have added more copies. Centralizing means the blog route SHAPE (paths +
 * template names) changes in exactly one place. The `template` values are kept
 * in lockstep with `BlogTemplateRoute.BLOG_TEMPLATES` (asserted by this module's
 * unit test).
 *
 * @module @puffin-core/marketing-shell/blog/blogTemplateRoutes
 */

const BLOG_TEMPLATE_ROUTES = Object.freeze([
  Object.freeze({ path: '/blog', template: 'blog-index' }),
  // WS-J — paginated index. 3 segments, so it cannot collide with the 2-segment
  // `/blog/:slug` post route regardless of declaration order.
  Object.freeze({ path: '/blog/page/:page', template: 'blog-index' }),
  Object.freeze({ path: '/blog/:slug', template: 'blog-post' }),
  Object.freeze({ path: '/blog/category/:category', template: 'blog-category' }),
  Object.freeze({ path: '/blog/tag/:tag', template: 'blog-tag' }),
]);

export default BLOG_TEMPLATE_ROUTES;
export { BLOG_TEMPLATE_ROUTES };
